import { PostAPI } from 'Components/Helper/Helpers';

export const BulkTransfer = async (request) => {
    return PostAPI(request, 'PayoutBulkTransfer/BulkTransfer');
};

export const Download = async (request) => {
    return PostAPI(request, 'PayoutBulkTransfer/GetTemplate');
};